import React from 'react'

const MyListBlockItem = ({ text, value }) => {
  return (
    <div>
        {/* <p>{text}</p>
        <p>{value}</p> */}
        <div>{text}</div>
        <div>{value}</div>
    </div>
  )
}

export default MyListBlockItem